import { AccountAdminMenu, AccountSettingsMenu, UserAdminMenu } from 'layout/Menus';
import { BreadcrumbItem } from 'types/BreadcrumbItem';
import { ACLCheck } from './Helpers';

import { APP_NAME } from './constants';

/**
 * Retrieves page metadata based on the given location.
 * @param {string} location - The location of the page.
 * @returns {{
 *  title: string;
 *  pageTitle?: string;
 *  breadcrumbs: BreadcrumbItem[];
 *  menu: any;
 * }} - The page metadata.
 */
export function pageMetadata(location: string): {
  title: string;
  pageTitle?: string;
  breadcrumbs: BreadcrumbItem[];
  menu: any;
} {
  let title: string;
  let breadcrumbs: BreadcrumbItem[];
  let menu: any;
  const hasEarlyAccessRead = ACLCheck(['read:early_access']);

  if (location === '/site_administration') {
    title = `Site Administration`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Site Administration' }];
  } else if (location === '/site_administration/suppliers') {
    title = `Suppliers`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Suppliers' }
    ];
  } else if (location === '/site_administration/products') {
    title = `Supplier Products`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Supplier Products' }
    ];
  } else if (location === '/site_administration/price_lists') {
    title = `Supplier Price Lists`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Supplier Price Lists' }
    ];
  } else if (location === '/site_administration/triage') {
    title = `Inquiry Triage`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Inquiry Triage' }
    ];
  } else if (location === '/site_administration/product_accuracy') {
    title = `Bill of Materials SKU Accuracy`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Bill of Materials SKU Accuracy' }
    ];
  } else if (location === '/site_administration/supplier_dynamics') {
    title = `Supplier Dynamics`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Supplier Dynamics' }
    ];
  } else if (location === '/site_administration/resellers') {
    title = `Resellers`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Resellers' }
    ];
  } else if (location === '/site_administration/supplier_mapping') {
    title = `Supplier Mapping`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Supplier Mapping' }
    ];
  } else if (location === '/site_administration/ai_config') {
    title = `Ai Config`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'AI Config' }
    ];
  } else if (location === '/site_administration/clients') {
    title = `Clients`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Clients' }
    ];
  } else if (location === '/site_administration/users') {
    title = `Users`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Users' }
    ];
  } else if (location === '/site_administration/account_admin') {
    title = `Account Admin`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Account Management' }
    ];
  } else if (location === '/site_administration/global_api_limits') {
    title = `Global API Limits`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Global API Limits' }
    ];
  } else if (location === '/site_administration/partner_acl_admin') {
    title = `Partner ACL Administration`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Partner ACL Administration' }
    ];
  } else if (location === '/site_administration/workbench') {
    title = `Workbench`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Workbench' }
    ];
  } else if (location === '/site_administration/permissions') {
    title = `Site Permissions`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Site Permissions' }
    ];
  } else if (location === '/site_administration/roles') {
    title = `User Roles`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'User Roles' }
    ];
  } else if (location === '/site_administration/community_moderation') {
    title = `Community Moderation`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Community Moderation' }
    ];
  } else if (location === '/site_administration/review_moderation') {
    title = `Supplier Review Moderation`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Supplier Review Moderation' }
    ];
  } else if (location === '/site_administration/banner_administration') {
    title = `Banner Administration`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Banner Administration' }
    ];
  } else if (location === '/site_administration/webinar_administration') {
    title = `Webinar Administration`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Site Administration', linkTo: '/site_administration' },
      { label: 'Webinar Administration' }
    ];
  } else if (location === '/add_single_deal') {
    title = `${APP_NAME}: Add Single Deal`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Smart Calendar™', linkTo: '/deal_calendar' },
      { label: 'Add Deal to Smart Calendar™' }
    ];
  } else if (location === '/add_multiple_deals') {
    title = `${APP_NAME}: Add Multiple Deals`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Smart Calendar™', linkTo: '/deal_calendar' },
      { label: 'Add Multiple Deals to Smart Calendar™' }
    ];
  } else if (location === '/upload_deals') {
    title = `${APP_NAME}: Add Bulk Deals`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/' },
      { label: 'Smart Calendar™', linkTo: '/deal_calendar' },
      { label: 'Add Bulk Deals to Smart Calendar™' }
    ];
  } else if (location === '/account_admin') {
    title = `${APP_NAME}: Account Administration`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Account Administration' }];
    menu = AccountAdminMenu;
  } else if (location === '/user_admin') {
    title = `${APP_NAME}: Personal Settings`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Personal Settings' }];
    menu = UserAdminMenu;
  } else if (location === '/notification_preferences') {
    title = `${APP_NAME}: Notification Preferences`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Notification Preferences' }];
    menu = UserAdminMenu;
  } else if (location === '/account_settings') {
    title = `${APP_NAME}: Account Settings`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Account Settings' }];
    menu = AccountSettingsMenu;
  } else if (location === '/banner_admin') {
    title = `${APP_NAME}: Banner Administration`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Banner Administration' }];
  } else if (location === '/canvas') {
    title = `${APP_NAME}: Canvas Editor`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Canvas Editor' }];
  } else if (location === '/subscription_purchases') {
    title = `${APP_NAME}: Subscription Purchases`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'All Submitted Deals' }];
  } else if (location === '/deals') {
    title = `${APP_NAME}: Submitted Deals`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Deal Management' }, { label: 'Submitted Deals' }];
  } else if (location === '/deal_calendar') {
    title = `${APP_NAME}: Deals`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Smart Calendar™' }];
  } else if (location === '/supplier_dynamics') {
    title = `${APP_NAME}: Supplier Dynamics`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Supplier Dynamics™' }];
  } else if (location === '/sb/benchmarks-products') {
    title = `Product Pricing Benchmark (BOM)`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '20' },
      { label: 'Product Pricing Benchmark (BOM)', key: '21b' }
    ];
    menu = null;
  } else if (location === '/sb/benchmarks/product') {
    title = `Product Pricing Benchmark`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '20' },
      { label: 'Product Pricing Benchmark', key: '21' }
    ];
    menu = null;
  } else if (location.startsWith('/research/analyst')) {
    title = `${APP_NAME}: NPI Research`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'NPI Research' }];
  } else if (location.startsWith('/pinpoint')) {
    title = `${APP_NAME}: NPI Pinpoint`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'NPI PinPoint™' }];
  } else if (location.startsWith('/submit_purchase')) {
    title = `${APP_NAME}: Request A Benchmark Report`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Request A Benchmark Report' }];
    menu = null;
  } else if (location.startsWith('/benchmark-report')) {
    title = `${APP_NAME}: Request A Benchmark Report`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Request A Benchmark Report' }];
    menu = null;
  } else if (location.startsWith('/deal_creation_success/')) {
    title = `${APP_NAME}: Deal Creation Success`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Deal Creation Success' }];
    menu = null;
  } else if (location.startsWith('/deal_details/')) {
    title = `${APP_NAME}: Deal Details`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Deal Details' }];
    menu = null;
  } else if (location === '/deal') {
    // Standardized Vantage deal create route — the benchmark request screen (was `/benchmark-report/new`).
    title = `${APP_NAME}: Request A Benchmark Report`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Request A Benchmark Report' }];
    menu = null;
  } else if (location.startsWith('/deal/view/')) {
    // Standardized Vantage deal view route — mirrors the SmartBench "View Deal" breadcrumb.
    title = `${APP_NAME}: View Deal`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'View Deal' }];
    menu = null;
  } else if (location === '/deal/request') {
    // New benchmark-request page. Must precede the `startsWith('/deal/')` edit branch below, which
    // would otherwise title this route "Edit Deal".
    title = `${APP_NAME}: Request A Benchmark Report`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Request A Benchmark Report' }];
    menu = null;
  } else if (location.startsWith('/deal/')) {
    // Standardized Vantage deal edit route (`/deal/:id`) — mirrors the SmartBench "Edit Deal" breadcrumb.
    title = `${APP_NAME}: Edit Deal`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Edit Deal' }];
    menu = null;
  } else if (location.startsWith('/calendar_deals/')) {
    title = `${APP_NAME}: Calendar Deals`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'Calendar Deals' }];
    menu = null;
  } else if (location.startsWith('/resources')) {
    title = `${APP_NAME}: NPI Sourcing Insights`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'NPI Sourcing Insights' }];
    menu = null;
  } else if (location.startsWith('/webinars')) {
    title = `${APP_NAME}: APEX Webinars`;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }, { label: 'APEX Webinars' }];
    menu = null;
  } else if (location === '/sb') {
    title = `${APP_NAME}: SmartBench Home`;
    breadcrumbs = [{ label: 'Home' }];
    menu = null;
  } else if (location === '/sb/deals') {
    title = `${APP_NAME}: SmartBench Home`;
    breadcrumbs = [{ label: 'Home', linkTo: '/sb' }];
    menu = null;
  } else if (location.startsWith('/sb/contract/')) {
    title = `Contract`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '15' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: '16' }]),
      { label: 'Contract', key: '17' }
    ];
    menu = null;
  } else if (location.startsWith('/sb/deal-mgmt/')) {
    title = `Deal Management`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '15' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: '16' }]),
      { label: 'Deal Management', key: '171' }
    ];
    menu = null;
  } else if (location.startsWith('/sb/analyst_update/')) {
    const isNew = location.includes('/new');
    title = isNew ? 'Create Deal' : 'Edit Deal';
    breadcrumbs = [{ label: 'Home', linkTo: '/sb', key: 'ad-home' }];
    if (!hasEarlyAccessRead) {
      breadcrumbs.push({ label: 'Contracts', linkTo: '/sb/contracts', key: 'ad-contracts' });
    }
    if (isNew) {
      breadcrumbs.push({ label: 'Create Deal', key: 'ad-create' });
    } else {
      // Extract deal ID from URL and create link to view page
      const dealId = location.split('/').pop();
      breadcrumbs.push(
        { label: 'Deal', linkTo: `/sb/analyst_view/${dealId}`, key: 'ad-view' },
        { label: 'Edit', key: 'ad-edit' }
      );
    }
    menu = null;
  } else if (location.startsWith('/sb/analyst_view/')) {
    title = 'Deal';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: 'ad-home' },
      { label: 'Deal', key: 'ad-view' }
    ];
    if (!hasEarlyAccessRead) {
      breadcrumbs.splice(1, 0, { label: 'Contracts', linkTo: '/sb/contracts', key: 'ad-contracts' });
    }
    menu = null;
  } else if (location === '/sb/deal/create') {
    title = 'Create New Deal';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '15' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: '16' }]),
      { label: 'Deal', key: '17' }
    ];
    menu = null;
  } else if (location === '/sb/deal/view' || location.startsWith('/sb/deal/view/')) {
    title = 'View Deal';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: 'ndv-home' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: 'ndv-contracts' }]),
      { label: 'View Deal', key: 'ndv-view' }
    ];
    menu = null;
  } else if (location === '/sb/deal') {
    title = 'Create New Deal';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: 'nd-home' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: 'nd-contracts' }]),
      { label: 'Create New Deal', key: 'nd-create' }
    ];
    menu = null;
  } else if (
    location.startsWith('/sb/deal/') &&
    !location.startsWith('/sb/deal/view') &&
    location !== '/sb/deal/create'
  ) {
    title = 'Edit Deal';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: 'nd-home' },
      ...(hasEarlyAccessRead ? [] : [{ label: 'Contracts', linkTo: '/sb/contracts', key: 'nd-contracts' }]),
      { label: 'Edit Deal', key: 'nd-edit' }
    ];
    menu = null;
  } else if (location === '/sb/contracts') {
    title = `Contracts`;
    // pageTitle = `Contracts`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '18' },
      { label: 'Contracts', key: '19' }
    ];
    menu = null;
  } else if (location === '/sb/reports') {
    title = `Reports`;
    // pageTitle = `Reports`;
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '23' },
      { label: 'Reports', key: '25' }
    ];
  } else if (location.startsWith('/sb/reports/builder')) {
    title = 'Report';
    // pageTitle = 'Start a new report';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '25' },
      { label: 'Reports', linkTo: '/sb/reports', key: '101' },
      { label: 'FMV Builder', key: '27' }
    ];
    menu = null;
  } else if (location.startsWith('/sb/reports/')) {
    title = 'Report';
    // pageTitle = 'Fair Market Value ReportViewer';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '25' },
      { label: 'Reports', linkTo: '/sb/reports', key: '105' },
      { label: 'Report', key: '27' }
    ];
    menu = null;
  } else if (location.startsWith('/sb/juggernaut')) {
    title = 'Juggernaut';
    breadcrumbs = [
      { label: 'Home', linkTo: '/sb', key: '25' },
      { label: 'Juggernaut', linkTo: '/sb/juggernaut', key: '107' }
    ];
    menu = null;
  } else {
    title = APP_NAME;
    breadcrumbs = [{ label: 'Home', linkTo: '/' }];
    menu = null;
  }

  return {
    title,
    breadcrumbs,
    menu
  };
}
